'use strict';

angular.module('msGoals').filter('mostRecentResponseDate', [function () {
  return function (responses) {
    if (responses && responses.length > 0) {
      var temp = _.sortBy(responses, 'datetime.unix').reverse();
      return angular.isObject(_.first(temp).datetime) ? _.first(temp).datetime : moment(_.first(temp).datetime);
    }
  };
}]);